import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Button, DialogOverlay, DialogOverlayActions, FlowGrid, Image, Paragraph, Separator } from '@fs/zion-ui'
import AttachFlowOnboardingImage from '../../../../assets/attachFlowOnboarding.png'

export default function AlreadyTurnedOnDialog({ overlay }) {
  const [t] = useTranslation()

  return (
    <DialogOverlay
      {...overlay}
      title={t('attachFlowOnboardingDialog.alreadyTurnedOn.title', "We've made a few changes")}
      subtitle={t('attachFlowOnboardingDialog.alreadyTurnedOn.subtitle', 'Thanks for your feedback')}
      footer={
        <DialogOverlayActions>
          <Button
            emphasis="high"
            color="gray"
            onClick={overlay.close}
            linkName="attach-flow-onboarding-already-turned-on-close"
            data-testid="already-turned-on-close"
          >
            {t('attachFlowOnboardingDialog.alreadyTurnedOn.close', 'Close')}
          </Button>
        </DialogOverlayActions>
      }
      nonClosable
    >
      <FlowGrid columnCount={1} orientation="vertical">
        <Image src={AttachFlowOnboardingImage} height={270} aria-hidden="true" />

        <>
          <Paragraph>{t('attachFlowOnboardingDialog.alreadyTurnedOn.whatsNew', "Here's what's new:")}</Paragraph>
          <Separator size="xxs" />
          <ul>
            <li>
              <Paragraph>
                <Trans i18nKey="attachFlowOnboardingDialog.alreadyTurnedOn.bullet1">
                  Attaching to a person in your Family Tree from <strong>Save Record</strong> now goes straight to
                  attaching the image.
                </Trans>
              </Paragraph>
            </li>
            <li>
              <Paragraph>
                <Trans i18nKey="attachFlowOnboardingDialog.alreadyTurnedOn.bullet2">
                  To add a name and its details from the image to your Family Tree, open the <strong>Names</strong> tab
                  to choose a name or add a missing one.
                </Trans>
              </Paragraph>
            </li>
            <li>
              <Paragraph>
                <Trans i18nKey="attachFlowOnboardingDialog.alreadyTurnedOn.bullet3">
                  Viewing and editing names now looks and works the same as adding a new name.
                </Trans>
              </Paragraph>
            </li>
          </ul>
        </>
      </FlowGrid>
    </DialogOverlay>
  )
}
